import { render, staticRenderFns } from "./UtilListingGalleryItem.vue?vue&type=template&id=70b16c30"
import script from "./UtilListingGalleryItem.vue?vue&type=script&lang=js"
export * from "./UtilListingGalleryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports